<div [ngClass]="{
    'showSpinnerContainer': spinner.showSpinner,
    'hideSpinnerContainer': !spinner.showSpinner
  }">
    <img src="assets/images/spinner.gif" alt="spinner">
</div>
